export default __webpack_public_path__ + "static/media/categories_active.1706ca87.svg";